import app from './app';

// spanish-latin-america
export default {
  app,
};
